<div class="containerStepper">
  @if (
    singleSelectParas &&
    singleSelectParas.length > 0 &&
    (!multiSelectParaDefinitions || multiSelectParaDefinitions.length === 0)
    ) {
    <div
      class="singleParamContainer"
      >
      <div fxLayout="column" fxLayoutAlign="center none">
        @for (para of singleSelectParas; track para) {
          <div>
            <param-values-editor
              [parameter]="para"
              (parameterValueChange)="parameterValueChanged($event)"
            ></param-values-editor>
          </div>
        }
      </div>
    </div>
  }

  @if (multiSelectParaDefinitions && multiSelectParaDefinitions.length > 0) {
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="center"
      animationDuration="0ms"
      >
    @if (singleSelectParas && singleSelectParas.length > 0) {
      <mat-tab label="Werte" style="padding-top: 10px">
        <div fxLayout="column" fxLayoutAlign="center none">
          @for (para of singleSelectParas; track para) {
            <div>
              <param-values-editor
                [parameter]="para"
                (parameterValueChange)="parameterValueChanged($event)"
              ></param-values-editor>
            </div>
          }
        </div>
      </mat-tab>
    }
    <!-- Render tabs for multiSelectParaDefinitions -->
    <ng-container>
      @for (multiSelectPara of multiSelectParaDefinitions; track multiSelectPara) {
        <mat-tab label="{{ multiSelectPara.para.Caption || multiSelectPara.para.Name }}">
          <div fxLayout="column" fxLayoutAlign="center none">
            <param-values-editor
              [parameter]="multiSelectPara.para"
              (parameterValueChange)="parameterValueChanged($event)"
            ></param-values-editor>
          </div>
        </mat-tab>
      }
    </ng-container>
  </mat-tab-group>
}

<div class="buttonContainer">
  <abc-button
    [stylingMode]="'contained'"
    [text]="res.get('ValuesEditorContainer-Cancel')"
    [width]="'110px'"
    style="margin-left: 10px"
    (onClick)="cancel()"
    >
</abc-button>
<abc-button
  [stylingMode]="'contained'"
  [text]="res.get('ValuesEditorContainer-Ok')"
  [width]="'110px'"
  (onClick)="apply()"
  >
</abc-button>
</div>
</div>
